import { IoClose } from "react-icons/io5";
import styled from "styled-components";

const Styled = styled.ol`
    align-items: flex-end;
    display: flex;
    flex-direction: column;
    list-style: none;
    margin: 0;
    padding: 0;

    button {
        align-items: center;
        background: transparent;
        border: none;
        display: flex;
        flex-direction: row;
        margin: 0;
        padding: 0;
        position: relative;
        text-align: right;

        svg {
            display: none;
            left: 100%;
            position: absolute;
        }

        &:enabled {
            cursor: pointer;

            &:hover {
                color: #445;

                svg {
                    display: block;
                    opacity: .5;
                }
            }
        }

        &:active {
            color: #667;
        }
    }
`;

interface ISelectionProps {
    items: {
        id: string
        name: string
    }[]
    onChange(
        update: (ids: string[]) => string[]
    ): void
}

export default function Selection(props: ISelectionProps) {
    const { disabled, items, onChange } = props;

    if (!items.length) return undefined;

    function remove(itemID: string) {
        onChange(
            (ids) => ids.filter(
                (id) => id !== itemID
            )
        );
    }

    return (
        <Styled>
            {
                items.map(
                    (item) => (
                        <li key={ item.id }>
                            <button disabled={ disabled } onClick={ () => remove(item.id) } type="button">
                                { item.name }
                                { !disabled && <IoClose /> }
                            </button>
                        </li>
                    )
                )
            }
        </Styled>
    );
}
